export const iconFontAwesomeCodingFileCode = (
	<i className="fa-solid fa-file-code"></i>
);
